const FromArrEditor = [{
		key: 'StartDate',
		title: "启效日期：",
		inputtype: "date",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 400
	},
	{
		key: 'EndDate',
		title: "有效期至：",
		inputtype: "date",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 400
	}
];
export default FromArrEditor;